/** Curated smiley + symbol set for the Rio/admin composers (Phase 7). */
export const COMPOSER_EMOJI_SET: readonly string[] = [
  '😀',
  '😁',
  '😂',
  '🤣',
  '😊',
  '😍',
  '😘',
  '😎',
  '🤩',
  '🙂',
  '😉',
  '😢',
  '😭',
  '😡',
  '🤔',
  '😴',
  '👍',
  '👎',
  '👏',
  '🙏',
  '🙌',
  '✌️',
  '🤝',
  '💪',
  '❤️',
  '🧡',
  '💛',
  '💚',
  '💙',
  '💜',
  '🖤',
  '💔',
  '✨',
  '🔥',
  '⭐',
  '💯',
  '🎉',
  '✅',
  '❌',
  '💬',
];

export function insertTextAtCursor(
  value: string,
  insert: string,
  start: number,
  end: number,
): { value: string; caret: number } {
  const safeStart = Math.max(0, Math.min(start, value.length));
  const safeEnd = Math.max(safeStart, Math.min(end, value.length));
  return {
    value: value.slice(0, safeStart) + insert + value.slice(safeEnd),
    caret: safeStart + insert.length,
  };
}
